<template>
    <section class="client-settings--menu">
        <ul>
            <li><router-link :to="{ name: 'client-settings-ui' }">{{ $t('com.file.settings.menu.ui-settings')
                    }}</router-link></li>
            <li><router-link :to="{ name: 'client-settings-integration' }">{{ $t('com.file.settings.menu.integration')
                    }}</router-link></li>
            <li><router-link :to="{ name: 'client-settings-custom-css' }">{{ $t('com.file.settings.menu.custom-css')
                    }}</router-link></li>
            <li v-if="roomMapModule"><router-link :to="{ name: 'client-settings-room-map' }">{{
                $t('com.file.settings.menu.room-map')
                    }}</router-link></li>
            <li><router-link :to="{ name: 'client-settings-placeholder' }">{{ $t('com.file.settings.menu.placeholder')
                    }}</router-link></li>
            <li><router-link :to="{ name: 'client-settings-invoice-data' }">{{ $t('com.file.settings.menu.invoice-data')
                    }}</router-link></li>
            <li><router-link :to="{ name: 'client-settings-discussion-profile' }">{{
                $t('com.file.settings.menu.discussion-profile') }}</router-link></li>
            <li><router-link :to="{ name: 'client-settings-voting' }">{{
                $t('com.file.settings.menu.voting') }}</router-link></li>
            <!-- <li><router-link :to="{ name: 'client-settings-notifications' }">{{ $t('com.file.settings.menu.notifications') }}</router-link></li>
            <li><router-link :to="{ name: 'client-settings-privacy' }">{{ $t('com.file.settings.menu.privacy') }}</router-link></li> -->
        </ul>
    </section>
</template>
<script lang="js">
import { encryptStorage } from '@/services/encrypt.service';
export default {
    name: "ClientSettingsMenu",
    data() {
        return {
            roomMapModule: encryptStorage.getItem('modules').ps,
        };
    }
}
</script>
<style lang="scss" scoped>
.client-settings--menu {
    background: linear-gradient(139.17deg, #00082c 0%, #004dcc 148.71%);
    padding-left: 48px;
    padding-right: 48px;
    ul {
        display: flex;
        padding: 0;
        margin: 0;
        list-style-type: none;

        li {
            display: flex; 
            align-items: center; 
            border-right: 1px solid #e8ebef;

            &:last-child {
                border-right: none;
            }

            a {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 15px 20px;
                color: #c6ccd6;
                font-weight: 600;
                font-size: 16px;
                text-decoration: none;
                height: 100%; 
                text-align: center;
                &:hover {
                    background: rgba(255, 255, 255, 0.2);
                }

                &.router-link-active {
                    background: rgba(255, 255, 255, 0.2);
                }
            }
        }
    }
}
</style>